import { EncartInfosMagasin } from '@components/encart-infos-magasin/models';
import { Block } from '@shared/models';

export const encartInfosMagasinMock: Block<EncartInfosMagasin> = {
  type: 'encart-infos-magasin',
  data: {
    store: {
      uuid: `1f02ff8e-be17-62c8-b7a4-efd44f4b8cf1`,
      name: `SoCoo'c Sainte Genevieve des Bois`,
      streetName: `Bât C magasin 10`,
      zipcode: `95520`,
      city: `Osny`,
      phone: `01 56 80 26 10`,
    },
    reviewStats: {
      totalReviews: 230,
      averageRating: 4.24,
    },
    gtmConfigReviewBtn: {
      event: 'click_cta_avis_magasin',
      group: 'avis',
      description: 'avis magasin {{nom du magasin}}',
      context: 'clic pour ouvrir panel avis',
    },
  },
};
